module.exports = __webpack_public_path__ + "static/img/emos.5e39ad6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/emos.jpg
// module id = Drd9
// module chunks = 0